import React from 'react';
import { Route, IndexRoute } from 'react-router';

import App from './components/App';
import HomePage from './components/HomePage';
import ProjectsPage from './components/ProjectsPage.js';
import MembersPage from './components/MembersPage.js';
import NewTaskPage from './components/NewTaskPage.js';
import NotFoundPage from './components/NotFoundPage.js';

export default (
  <Route path="/" component={App}>
    <IndexRoute component={HomePage}/>
    <Route path="projects" component={ProjectsPage}/>
    <Route path="members" component={MembersPage}/>
    <Route path="members/tasks/new" component={NewTaskPage}/>
    <Route path="*" component={NotFoundPage}/>
  </Route>
);



/** WEBPACK FOOTER **
 ** ./src/routes.js
 **/